import * as net from 'util/Net';

import type {ContactUsFeedbackType} from './contactUsConfig';

/**
 * Send one feedback submission to the Model Hub product team.
 *
 * The backend derives tenant, user, and credit-usage context itself, and rate limits submissions per
 * user, returning a 429 with a user-readable message once the hourly allowance is used up.
 */
export async function submitModelHubFeedback(
  feedbackType: ContactUsFeedbackType,
  note: string
): Promise<void> {
  await net.postJSONPromise({
    url: '/1/api/model-hub/feedback',
    data: {feedbackType, note},
  });
}
